import { render, staticRenderFns } from "./promocode-create.vue?vue&type=template&id=04f80fba"
import script from "./promocode-create.vue?vue&type=script&lang=js"
export * from "./promocode-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports